import React, { useCallback, useMemo, useState } from "react";
import { ChildrenProps } from "../Models/componentModel";
import {
    CommonResponseModel,
    LogoutResponse,
    SigninPayloadModel,
    UserMeResponseDataModel,
} from "../Models/axiosModel";
import agent from "../service/api";

const UserContext = React.createContext<UserContextPayload | undefined>(
    undefined
);

export interface UserContextPayload {

    UserMe: () => Promise<CommonResponseModel<UserMeResponseDataModel>>;
    userDetail: UserMeResponseDataModel;
    setUserDetail: React.Dispatch<React.SetStateAction<UserMeResponseDataModel>>;

    SigninAPIFunction: (payload: SigninPayloadModel) => any
    signinFormDetails: SigninPayloadModel
    setSigninFormDetails: React.Dispatch<React.SetStateAction<SigninPayloadModel>>;

    flagLoader: boolean
    setFlagLoader: React.Dispatch<React.SetStateAction<boolean>>

    drawerOpen: boolean;
    setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>

    Logout: () => Promise<CommonResponseModel<LogoutResponse>>
    signinWithGoogle: () => Promise<any>

    forgetPasswordAPI: any
    resetPasswordAPI: any

    newUserRegisterAPI: any

    getUserRoleDetails: any

    resendVerifyLinkAPI: any

    verifyTokenAPI: any

    getCompanyLogoAPI: any

    companyDetails: any
    setCompanyDetails: any

    verifySSOtokenAPI: any
}

const UserProvider = ({ children }: ChildrenProps) => {

    const emptyUserDetails = {
        access_token: "",
        flagLoggedIn: null,
        user_data: {
            user_profile_image: null, // Changed to `null` to match the type
            user_profile_image_id: null, // Changed to `null` to match the type
            user_id: 0, // Initialized as `0`, assuming `user_id` cannot be null
            user_name: null,
            firstname: null,
            lastname: null, // Changed to `null` for consistency
            user_email: null,
            user_contact: null,
            user_company_id: null, // Changed to `null` to match the type
            user_company_name: null,
            user_role_id: "", // These are empty strings if they must be non-null
            user_role_type: "",
            user_status_id: "",
            user_status_name: "",
            user_license: "",
            user_agreement: "",
            cookie_flag: "",
        }
    }

    const signinIntialFormDetails = {
        email: '',
        password: '',
        remember_me_flag: true
    }

    const [userDetail, setUserDetail] = useState<UserMeResponseDataModel>(emptyUserDetails);
    const [flagLoader, setFlagLoader] = useState<boolean>(false);
    const [signinFormDetails, setSigninFormDetails] = useState<SigninPayloadModel>(signinIntialFormDetails);
    const [drawerOpen, setDrawerOpen] = useState<boolean>(true)
    const [companyDetails, setCompanyDetails] = useState([])

    const SigninAPIFunction = useCallback(async (payload: SigninPayloadModel) => {
        const response = await agent.signinAPI.post(payload);
        return response;
    }, []);

    const getCompanyLogoAPI = useCallback(async () => {
        const response = await agent.GetCompanyLogoAPI.get();
        return response
    }, []);

    const UserMe = useCallback(async () => {
        const response = await agent.UserMeGlobalAPI.get();
        return response;
    }, []);

    const Logout = useCallback(async () => {
        const response = await agent.logoutAPI.post();
        return response;
    }, []);

    const signinWithGoogle = useCallback(async () => {
        const response = await agent.signinWithGoogleAPI.get();
        return response;
    }, []);

    const forgetPasswordAPI = useCallback(async (payload: any) => {
        const response = await agent.forgetPasswordAPI.post(payload)
        return response;
    }, []);

    const resetPasswordAPI = useCallback(async (payload: any) => {
        const response = await agent.resetPasswordAPI.post(payload);
        return response;
    }, []);

    const newUserRegisterAPI = useCallback(async (payload: any) => {
        const response = await agent.newUserRegisterAPI.post(payload);
        return response
    }, []);

    const getUserRoleDetails = useCallback(async () => {
        const response = await agent.getUserRoleDetailsAPI.get();
        return response
    }, []);

    const resendVerifyLinkAPI = useCallback(async (payload: any) => {
        const response = await agent.resendVerifyLinkAPI.post(payload);
        return response
    }, []);

    const verifyTokenAPI = useCallback(async (verify_token: any) => {
        const response = await agent.verifyTokenAPI.get(verify_token);
        return response
    }, []);

    const verifySSOtokenAPI = useCallback(async (verify_token: any) => {
        const response = await agent.verifySSOtokenAPI.get(verify_token);
        return response
    }, []);

    const contextValue = useMemo<UserContextPayload>(() => ({
        UserMe,
        userDetail,
        setUserDetail,
        flagLoader,
        setFlagLoader,
        signinFormDetails,
        setSigninFormDetails,
        SigninAPIFunction,
        drawerOpen,
        setDrawerOpen,
        Logout,
        signinWithGoogle,
        forgetPasswordAPI,
        resetPasswordAPI,
        newUserRegisterAPI,
        getUserRoleDetails,
        resendVerifyLinkAPI,
        verifyTokenAPI,
        getCompanyLogoAPI,
        companyDetails,
        setCompanyDetails,
        verifySSOtokenAPI
    }), [
        UserMe,
        userDetail,
        flagLoader,
        signinFormDetails,
        SigninAPIFunction,
        drawerOpen,
        Logout,
        signinWithGoogle,
        forgetPasswordAPI,
        resetPasswordAPI,
        newUserRegisterAPI,
        getUserRoleDetails,
        resendVerifyLinkAPI,
        verifyTokenAPI,
        getCompanyLogoAPI,
        companyDetails,
        verifySSOtokenAPI,
    ]);

    return (
        <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
    );
};

export { UserContext, UserProvider };
